// O PostHog do navegador, menos o que muda por página: filtro de eventos, máscara da gravação,
// identificação, amostra de velocidade e, por último, o init (posthog_init.js). Ia embutido no
// HTML de toda página, ~16 KB crus e ~6 KB com gzip, metade do HTML comprimido. Com isso a página
// passava da janela inicial do TCP e custava uma ida e volta a mais até o Brasil (~145 ms). Daqui o
// navegador baixa uma vez da CDN, reaproveita do cache, e carrega com async: não segura a página.
//
// O nome não cita o PostHog de propósito: bloqueador de anúncio corta URL com "posthog". Bloqueado,
// não há init, e nada sai sem filtro nem é gravado sem máscara.







